import {ProductDetails} from "@app/core/product/domain/dtos/product-details";
import {ProductFactsMapper} from "@app/core/product/infrastructure/mappers/product-facts.mapper";
import {PriceMapper} from "@app/core/shared/infrastructure/mappers/price.mapper";

export class ProductDetailsMapper {
    static deserialize(param: any): ProductDetails {
        return {
            code: param.code,
            name: param.name,
            description: param.description,
            image: param.image,
            category: param.category,
            priceWithTax: PriceMapper.deserialize(param.price),
            price: PriceMapper.deserialize(param.boxPrice),
            units: param.units,
            unitPrice: PriceMapper.deserialize(param.unitPrice),
            isNew: param.new,
            isTopProducts: param.top,
            isFavorite: param.favorite ?? false,
            specs: param.specs ? ProductFactsMapper.deserialize(param.specs) : undefined,
            datasheet: param.datasheet === '' ? null : param.datasheet,
        }
    }
}
